import { Controller } from "@hotwired/stimulus"
import Pickr from "@simonwep/pickr/dist/pickr.min.js"
import "@simonwep/pickr/dist/themes/monolith.min.css"

const DEFAULT_SWATCHES = ["#bf1a2d", "#222429", "#25292c"]
const EARLIEST_DISCONNECT_DELTA_IN_MS = 500

const buildComponents = (useOpacity) => ({
  preview: true,
  hue: true,
  opacity: useOpacity,
  interaction: {
    hex: false,
    rgba: false,
    hsla: false,
    hsva: false,
    cmyk: false,
    input: true,
    clear: false,
    save: true,
  },
})

export default class extends Controller {
  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) { return }

    this.createdAt = Date.now()
    this.container = this.element.closest(".color-picker-container")
    this.input = this.container?.querySelector(`[data-color-input-for="${this.fieldName}"]`)
    if (!this.input) { return }

    this.pickr = Pickr.create({
      el: this.element,
      theme: "monolith",
      components: buildComponents(this.useOpacity),
      default: this.input.value,
      defaultRepresentation: this.useOpacity ? "HEXA" : "HEX",
      lockOpacity: !this.useOpacity,
      strings: { save: this.element.dataset.translationSave },
      swatches: DEFAULT_SWATCHES,
    })

    this.pickr.on("save", (_color, pickr) => { this.input.value = pickr.getColor().toHEXA().toString() })

    this.swatchHandler = (event) => {
      const swatch = event.target.closest("[data-color-picker-color]")
      if (swatch) { this.pickr.setColor(swatch.dataset.colorPickerColor) }
    }

    this.container.addEventListener("click", this.swatchHandler)
  }

  disconnect() {
    // We sometimes get disocnnects immediately after creating the picker. To prevent this, we only actually tear down the controller if the disconnect happens after a certain delay, which signals an "actual" disconnect due to a browser navigation etc.
    if (Date.now() - this.createdAt < EARLIEST_DISCONNECT_DELTA_IN_MS) { return }

    this.container?.removeEventListener("click", this.swatchHandler)
    this.pickr?.destroyAndRemove()
  }

  get fieldName() { return this.element.dataset.colorPickerFor }
  get useOpacity() { return "colorPickerOpacity" in this.element.dataset }
}
